import React, { useEffect, useState } from 'react';
import { IconButton, Modal } from '@common-ui/ui';
import { Close, NavigateBefore, NavigateNext } from '@mui/icons-material';

const styles = {
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    zIndex: 9999,
  },
  modalContent: {
    position: 'relative',
    maxWidth: '90%',
    maxHeight: '90%',
  },
  closeIconContainer: {
    position: 'absolute',
    border: '1px solid rgb(50, 50, 50)',
    top: 8,
    right: 8,
    zIndex: 1,
    cursor: 'pointer',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
  arrowContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
    cursor: 'pointer',
  },
  leftArrow: {
    left: 16,
  },
  rightArrow: {
    right: 16,
  },
};

export default function ImageModal({
  selectedImage: clientSelectedImage = 0,
  images = [],
  open = false,
  onClose,
}) {
  if (!Array.isArray(images)) {
    images = [images];
  }

  const [currentImageIndex, setCurrentImageIndex] = useState(clientSelectedImage);

  const handleModalClose = () => {
    onClose();
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  useEffect(() => {
    setCurrentImageIndex(clientSelectedImage);
  }, [clientSelectedImage]);

  return (
    <Modal open={open} onClose={onClose}>
      <div style={styles.modal}>
        <div style={styles.modalContent}>
          <IconButton style={styles.closeIconContainer} color="primary" onClick={handleModalClose}>
            <Close style={styles.closeIcon} />
          </IconButton>
          {images && (
            <>
              <IconButton
                style={{ ...styles.arrowContainer, ...styles.leftArrow }}
                onClick={handlePrevImage}
              >
                <NavigateBefore />
              </IconButton>

              <IconButton
                style={{ ...styles.arrowContainer, ...styles.rightArrow }}
                onClick={handleNextImage}
              >
                <NavigateNext />
              </IconButton>

              <img src={images[currentImageIndex]} alt="Modal Image" style={styles.image} />
            </>
          )}
        </div>
      </div>
    </Modal>
  );
}
